module.exports = __webpack_public_path__ + "static/media/bell-on.2beaaf94.svg";